import api from '../lib/api';
import type { Company } from '../types/company';

interface CompanyFilters {
  company_name?: string;
  cnpj?: string;
  phone?: string;
  email?: string;
  city?: string;
  page?: number;
  limit?: number;
}

interface CompanyResponse {
  data: Company[];
  pagination: {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
  };
}

class CompanyService {
  async getCompanies(filters: CompanyFilters = {}): Promise<CompanyResponse> {
    const response = await api.get('/ace/companies', { params: filters });
    return response.data;
  }

  async createCompany(data: Partial<Company>): Promise<Company> {
    const response = await api.post('/ace/companies', data);
    return response.data;
  }

  async updateCompany(id: number, data: Partial<Company>): Promise<Company> {
    const response = await api.put(`/ace/companies/${id}`, data);
    return response.data;
  }

  async deleteCompany(id: number): Promise<void> {
    await api.delete(`/ace/companies/${id}`);
  }
}

export default new CompanyService();
